module.exports = __webpack_public_path__ + "img/mastercard_sc.7057522.svg";